/**
 * Dependencies
 */
import React, {Component} from 'react';
import { setResumeData } from "../../actions/resume";
import { connect } from 'react-redux';

/**
 * Components
 */
import Special from "../../components/Special/index";

class SpecialContainer extends  Component {
  render() {
    const { match, user } = this.props;
    const specialName = match.params.name;
    return (
      <div className="aff-container-vcard">
        <div className="aaf-vcard" style={{ paddingTop: "0px", height: "100%" }}>
          <Special specialName={specialName} setResume={this.props.setResumeData} user={user}/>
        </div>
      </div>
    )
  }
}


export default connect(null, { setResumeData })(SpecialContainer);



// WEBPACK FOOTER //
// ./src/containers/Special/index.jsx